import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import axios from 'axios'
import Modal from 'react-bootstrap/Modal'
import Cookies from 'universal-cookie'
import { v4 as uuidv4 } from 'uuid'
import { BiSolidLocationPlus } from 'react-icons/bi'
import { BsArrowRight, BsClock, BsSearch } from 'react-icons/bs'
import Header from './layouts/Header'
import IndexedEvents from './IndexedEvents'
import { API_URL } from './config'
import './App.css'
import './Theme.css'
import './Home.css'

const cookies = new Cookies()
if (!cookies.get('clientid')) {
  cookies.set('clientid', uuidv4().toUpperCase())
}

const BsTicketPerforated = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinejoin="round"
    strokeLinecap="round"
    {...props}
  >
    <path d="M4 6h16a1 1 0 0 1 1 1v3a2 2 0 0 0 0 4v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3a2 2 0 0 0 0-4V7a1 1 0 0 1 1-1z" />
    <path d="M14 8v1.5M14 11.25v1.5M14 14.5V16" />
  </svg>
)

const WS = `${API_URL}/apps/kscanner/webservices.php`
const pad = (n) => String(n).padStart(2, '0')

const todayISO = () => {
  const d = new Date()
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

const posterUrl = (item) =>
  `${API_URL}/apps/kscanner/posters/${item.businessid}/${item.eventid}/${item.poster}`

// Descriptions come back as HTML; card previews only need plain text.
const plainText = (html = '', max = 160) => {
  const text = new DOMParser().parseFromString(String(html), 'text/html').body.textContent || ''
  const clean = text.replace(/\s+/g, ' ').trim()
  return clean.length > max ? clean.slice(0, max).trimEnd() + '…' : clean
}

const hidePoster = (e) => {
  e.currentTarget.style.display = 'none'
}

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      events: [],
      loading: true,
      error: null,
      provinces: [],
      categories: [],
      query: '',
      category: '',
      email: '',
      phone: '',
      customername: '',
      affiliate: '',
      affiliate_email: '',
      affiliate_phone: '',
      resumeModal: false,
      detailModal: false,
    }
    this.eventsRef = React.createRef()
  }

  componentDidMount() {
    document.title = "Karamale - World's digital ticket software"
    this.loadAffiliate()
    this.loadCustomer()
    this.loadEvents()
    this.loadFilters()
  }

  loadAffiliate() {
    const fromUrl = new URLSearchParams(window.location.search).get('affiliateid')
    const stored = localStorage.getItem('affiliateid')
    if (fromUrl && (!stored || stored === 'null')) {
      localStorage.setItem('affiliateid', fromUrl)
    }
    const affiliateid = localStorage.getItem('affiliateid')
    if (!affiliateid || affiliateid === 'null') return

    axios
      .get(WS, { params: { query: 'AFFILIATEDETAILS', affiliateid } })
      .then((res) => {
        if (!res.data || !res.data.affiliate) return
        this.setState({
          affiliate: res.data.affiliate,
          affiliate_email: res.data.email,
          affiliate_phone: res.data.phone,
          resumeModal: true,
        })
      })
      .catch(() => {})
  }

  loadCustomer() {
    const customerid = localStorage.getItem('customerid')
    if (customerid === null) return
    axios
      .get(WS, {
        params: { query: 'CUSTOMERDETAILS', accountid: customerid },
        withCredentials: true,
      })
      .then((res) => {
        this.setState({
          email: res.data.email,
          phone: res.data.phone,
          customername: res.data.customername,
        })
      })
      .catch(() => {})
  }

  loadEvents() {
    this.setState({ loading: true, error: null })
    axios
      .get(WS, { params: { query: 'EVENTS' } })
      .then((res) => {
        this.setState({ events: Array.isArray(res.data) ? res.data : [], loading: false })
      })
      .catch((error) => this.setState({ error, loading: false }))
  }

  loadFilters() {
    axios
      .get(WS, { params: { query: 'PROVINCES' } })
      .then((res) => this.setState({ provinces: Array.isArray(res.data) ? res.data : [] }))
      .catch(() => {})
    axios
      .get(WS, { params: { query: 'EVENTCATEGORY', limit: 9 } })
      .then((res) => this.setState({ categories: Array.isArray(res.data) ? res.data : [] }))
      .catch(() => {})
  }

  cancel = () => this.setState({ resumeModal: false, detailModal: false })
  details = () => this.setState({ resumeModal: false, detailModal: true })
  back = () => this.setState({ resumeModal: true, detailModal: false })
  signUp = () => this.props.history.push({ pathname: '/organiser-registration' })
  learnMore = () => this.props.history.push({ pathname: '/aboutkaramale' })

  onSearch = (e) => {
    e.preventDefault()
    if (this.eventsRef.current) {
      this.eventsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  onProvince = (e) => {
    const provinceid = e.target.value
    if (!provinceid) return
    const p = this.state.provinces.find((x) => String(x.provinceid) === provinceid)
    this.props.history.push('/explore', {
      fromHome: true,
      provinceid,
      category: '',
      province: p ? p.province : '',
    })
  }

  clearFilters = () => this.setState({ query: '', category: '' })

  eventLink = (item, session) => ({
    pathname: `/event/${item.eventid}/tickets`,
    state: {
      fromHome: true,
      eventid: item.eventid,
      eventDate: item.event_day,
      fulldate: session.today,
      customerid: session.customerid,
      posterUri: posterUrl(item),
      accountid: session.accountid,
      accounttype: session.accounttype,
      customername: this.state.customername,
      email: this.state.email,
      phone: this.state.phone,
      venue: item.event_location,
      description: item.event_des,
      businessid: item.businessid,
      poster: item.poster,
      eventname: item.eventname,
      eventday: item.eventday,
      starttime: item.start_time,
      endtime: item.finish_time,
      previousPage: '',
      campaignStatus: 'running',
      category: '',
    },
  })

  renderTicket(item, session, i) {
    return (
      <Link
        key={item.eventid || i}
        to={this.eventLink(item, session)}
        className="kx-ticket"
        aria-label={`${item.event_name}, ${item.eventday}`}
      >
        <div className="kx-ticket__poster">
          <BsTicketPerforated aria-hidden="true" />
          <img src={posterUrl(item)} alt="" loading="lazy" onError={hidePoster} />
          {item.eventcategory && <span className="kx-ticket__cat">{item.eventcategory}</span>}
        </div>
        <div className="kx-ticket__body">
          <h3 className="kx-ticket__title">{item.event_name}</h3>
          <p className="kx-ticket__place">
            <BiSolidLocationPlus aria-hidden="true" />
            <span>{item.event_location}</span>
          </p>
          <p className="kx-ticket__desc">{plainText(item.event_des)}</p>
        </div>
        <div className="kx-ticket__stub">
          <div className="kx-ticket__when">
            <strong>{item.eventday}</strong>
            {item.start_time && (
              <span>
                <BsClock aria-hidden="true" /> {item.start_time}
              </span>
            )}
          </div>
          <span className="kx-ticket__cta">
            Get tickets <BsArrowRight aria-hidden="true" />
          </span>
        </div>
      </Link>
    )
  }

  render() {
    const isCustomer = localStorage.getItem('customername') !== null

    if (!isCustomer) {
      if (
        localStorage.getItem('businessname') !== null &&
        localStorage.getItem('accounttype') !== null
      ) {
        return <Redirect to="/dashboard" />
      }
      if (localStorage.getItem('partnerid') !== null) {
        return <Redirect to="/in" />
      }
    }

    const {
      events,
      loading,
      error,
      provinces,
      categories,
      query,
      category,
      affiliate,
      affiliate_email,
      affiliate_phone,
    } = this.state

    const today = todayISO()
    const hasId = localStorage.getItem('customerid') !== null
    const session = {
      today,
      customerid: hasId ? localStorage.getItem('customerid') : 0,
      accountid: hasId ? localStorage.getItem('customerid') : 0,
      accounttype: hasId ? localStorage.getItem('accounttype') : '',
    }

    // Same rule as before: hide upcoming events whose balance is below 3.5.
    const visible = events.filter((e) => !(e.balance < 3.5 && e.event_day > today))
    const q = query.trim().toLowerCase()
    const shown = visible.filter(
      (e) =>
        (!category || e.eventcategory === category) &&
        (!q || `${e.event_name || ''} ${e.event_location || ''}`.toLowerCase().includes(q)),
    )
    const filtering = Boolean(q || category)
    const stack = !loading && !error ? visible.slice(0, 2) : []

    return (
      <div className="kx-page">
        <Header />

        {/* ---------- Hero (guests only) ---------- */}
        {!isCustomer && (
          <section className="kx-hero" aria-labelledby="kx-hero-title">
            <div
              className={`kx-wrap kx-hero__inner ${
                stack.length ? 'kx-hero__inner--with-stack' : ''
              }`}
            >
              <div>
                <h1 id="kx-hero-title" className="kx-hero__title">
                  Find your next event
                </h1>
                <p className="kx-hero__sub">
                  Concerts, festivals and experiences near you. Pick an event, buy your ticket, walk
                  in.
                </p>

                <form className="kx-search" onSubmit={this.onSearch} role="search">
                  <label className="kx-search__field">
                    <BsSearch aria-hidden="true" />
                    <input
                      type="search"
                      placeholder="Search events or venues"
                      aria-label="Search events or venues"
                      value={query}
                      onChange={(e) => this.setState({ query: e.target.value })}
                    />
                  </label>
                  <label className="kx-search__field">
                    <BiSolidLocationPlus aria-hidden="true" />
                    <select aria-label="Browse by province" value="" onChange={this.onProvince}>
                      <option value="">All provinces</option>
                      {provinces.map((p) => (
                        <option key={p.provinceid} value={p.provinceid}>
                          {p.province}
                        </option>
                      ))}
                    </select>
                  </label>
                  <button type="submit" className="kx-btn kx-btn--brand">
                    Find events
                  </button>
                </form>

                <Link to="/explore" className="kx-hero__browse">
                  Browse all events
                </Link>
              </div>

              {stack.length > 0 && (
                <div className="kx-hero__stack" aria-hidden="true">
                  {stack.map((item, i) => (
                    <Link
                      key={item.eventid || i}
                      to={this.eventLink(item, session)}
                      className={`kx-mini ${i === 0 ? 'kx-mini--a' : 'kx-mini--b'}`}
                      tabIndex={-1}
                    >
                      <div
                        className="kx-mini__img"
                        style={{ backgroundImage: `url(${posterUrl(item)})` }}
                      />
                      <div className="kx-mini__body">
                        <p className="kx-mini__title">{item.event_name}</p>
                        <span className="kx-mini__meta">{item.eventday}</span>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </section>
        )}

        {/* ---------- Events ---------- */}
        <section className="kx-section" ref={this.eventsRef} id="events" aria-live="polite">
          <div className="kx-wrap">
            <div className="kx-head">
              <div>
                <h2 className="kx-head__title">Upcoming events</h2>
                <p className="kx-head__sub">
                  Concerts, festivals and experiences happening around you.
                </p>
              </div>
              {!loading && !error && (
                <span className="kx-head__count">
                  {shown.length} {shown.length === 1 ? 'event' : 'events'}
                </span>
              )}
            </div>

            {isCustomer && (
              <div className="kx-search kx-search--inline">
                <label className="kx-search__field">
                  <BsSearch aria-hidden="true" />
                  <input
                    type="search"
                    placeholder="Search events or venues"
                    aria-label="Search events or venues"
                    value={query}
                    onChange={(e) => this.setState({ query: e.target.value })}
                  />
                </label>
              </div>
            )}

            {categories.length > 0 && (
              <div className="kx-toolbar">
                <div className="kx-chips" role="group" aria-label="Filter by category">
                  <button
                    type="button"
                    className={`kx-chip ${!category ? 'is-active' : ''}`}
                    aria-pressed={!category}
                    onClick={() => this.setState({ category: '' })}
                  >
                    All
                  </button>
                  {categories.map((c) => (
                    <button
                      key={c.category}
                      type="button"
                      className={`kx-chip ${category === c.category ? 'is-active' : ''}`}
                      aria-pressed={category === c.category}
                      onClick={() => this.setState({ category: c.category })}
                    >
                      {c.category}
                    </button>
                  ))}
                  <Link to="/categories" className="kx-chip kx-chip--dashed">
                    More categories
                  </Link>
                </div>
              </div>
            )}

            {loading && (
              <div className="kx-grid" aria-busy="true" aria-label="Loading events">
                {Array.from({ length: 6 }).map((_, i) => (
                  <div className="kx-skel" key={i}>
                    <div className="kx-skel__img" />
                    <div className="kx-skel__body">
                      <div className="kx-skel__line" />
                      <div className="kx-skel__line" />
                      <div className="kx-skel__line" />
                    </div>
                  </div>
                ))}
              </div>
            )}

            {!loading && error && (
              <div className="kx-state" role="alert">
                <BsTicketPerforated className="kx-state__icon" aria-hidden="true" />
                <h3>We couldn't load events</h3>
                <p>Check your connection and try again.</p>
                <div className="kx-state__actions">
                  <button
                    type="button"
                    className="kx-btn kx-btn--ink"
                    onClick={() => this.loadEvents()}
                  >
                    Try again
                  </button>
                </div>
              </div>
            )}

            {!loading && !error && shown.length === 0 && (
              <div className="kx-state">
                <BsTicketPerforated className="kx-state__icon" aria-hidden="true" />
                <h3>{filtering ? 'No events match your search' : 'No upcoming events yet'}</h3>
                <p>
                  {filtering
                    ? 'Try a different name or category, or clear your filters.'
                    : 'New events are added often. Check back soon or browse everything on Explore.'}
                </p>
                <div className="kx-state__actions">
                  {filtering && (
                    <button
                      type="button"
                      className="kx-btn kx-btn--ink"
                      onClick={this.clearFilters}
                    >
                      Clear filters
                    </button>
                  )}
                  <Link to="/explore" className="kx-btn kx-btn--ghost">
                    Browse all events
                  </Link>
                </div>
              </div>
            )}

            {!loading && !error && shown.length > 0 && (
              <div className="kx-grid">
                {shown.map((item, i) => this.renderTicket(item, session, i))}
              </div>
            )}
          </div>
        </section>

        <section className="kx-section kx-section--tight">
          <div className="kx-wrap">
            <IndexedEvents />
          </div>
        </section>

        {/* ---------- How it works + organiser/affiliate (guests only) ---------- */}
        {!isCustomer && (
          <>
            <section className="kx-section kx-section--tight" aria-labelledby="kx-how">
              <div className="kx-wrap">
                <div className="kx-head">
                  <h2 id="kx-how" className="kx-head__title">
                    How it works
                  </h2>
                </div>
                <ol className="kx-steps">
                  <li className="kx-step">
                    <span className="kx-step__n">1</span>
                    <h3>Pick an event</h3>
                    <p>Search by name, venue or category, then open the event you want.</p>
                  </li>
                  <li className="kx-step">
                    <span className="kx-step__n">2</span>
                    <h3>Buy your ticket</h3>
                    <p>Choose your ticket type and pay online.</p>
                  </li>
                  <li className="kx-step">
                    <span className="kx-step__n">3</span>
                    <h3>Walk in</h3>
                    <p>Show your ticket at the door and enjoy the event.</p>
                  </li>
                </ol>
              </div>
            </section>

            <section className="kx-section kx-section--tight">
              <div className="kx-wrap kx-cta-grid">
                <div className="kx-panel kx-panel--dark">
                  <h2>Sell tickets on Karamale</h2>
                  <p>
                    Create an organiser account, publish your event and get paid with transparent
                    payouts.
                  </p>
                  <div className="kx-panel__actions">
                    <Link to="/organiser-registration" className="kx-btn kx-btn--brand">
                      Get started
                    </Link>
                    <Link to="/about" className="kx-btn kx-btn--ghost-light">
                      Learn more
                    </Link>
                  </div>
                </div>

                <div className="kx-panel">
                  <h2>Earn as an affiliate</h2>
                  <p>
                    Refer organisers with your unique link. When they start selling tickets, you
                    earn up to 30%.
                  </p>
                  <div className="kx-panel__actions">
                    <Link to="/affiliate-registration" className="kx-btn kx-btn--ink">
                      Get started
                    </Link>
                    <Link to="/aboutsalesparnter" className="kx-btn kx-btn--ghost">
                      Learn more
                    </Link>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {/* ---------- Affiliate invite modals ---------- */}
        <Modal
          show={this.state.resumeModal}
          onHide={this.cancel}
          centered
          dialogClassName="kx-modal"
        >
          <div className="kx-modal__body">
            <span className="kx-modal__icon">
              <BsTicketPerforated aria-hidden="true" />
            </span>
            <h2 className="kx-modal__title">You're invited to Karamale</h2>
            <p className="kx-modal__text">
              {affiliate} invited you to create events and sell tickets with transparent payouts.
            </p>
            <div className="kx-modal__actions">
              <button type="button" className="kx-btn kx-btn--brand" onClick={this.signUp}>
                Sign up as an organiser
              </button>
              <button type="button" className="kx-btn kx-btn--ghost" onClick={this.learnMore}>
                Learn more
              </button>
            </div>
            <div className="kx-modal__foot">
              <button type="button" className="kx-link" onClick={this.details}>
                Contact {affiliate}
              </button>
              <button type="button" className="kx-link" onClick={this.cancel}>
                Close
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.detailModal}
          onHide={this.cancel}
          centered
          dialogClassName="kx-modal"
        >
          <div className="kx-modal__body">
            <h2 className="kx-modal__title">{affiliate}</h2>
            <p className="kx-modal__text">
              Reach out if you have questions about joining Karamale.
            </p>
            <div className="kx-modal__contact">
              {affiliate_email && <a href={`mailto:${affiliate_email}`}>{affiliate_email}</a>}
              {affiliate_phone && <a href={`tel:${affiliate_phone}`}>{affiliate_phone}</a>}
            </div>
            <div className="kx-modal__actions">
              <button type="button" className="kx-btn kx-btn--ink" onClick={this.back}>
                Back
              </button>
            </div>
            <div className="kx-modal__foot">
              <button type="button" className="kx-link" onClick={this.cancel}>
                Close
              </button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

export default Home
